import React from 'react'

const Loading = props => <div><div className="loading">
	<div></div>
	<div></div>
</div>
{props.children}
</div>

export default Loading